import React from "react";
import DueDateSection from "./duedate-section";
import SelectAssignee from "./SelectAssignee";
import SelectStatus from "./SelectStatus";
import TypeSelection from "./TypeSelection";
import PrioritySelection from "./PrioritySelection";
import TagSelection from "./tag-selection";
import { TicketGroup } from "../../types";
import { ITicketFormData } from "../../containers/Tickets/types";
import { useSelector } from "react-redux";
import { selectTicketTypes } from "app/redux/selector";

interface Props {
  onOpen: () => void;
  onClose: () => void;
  form: ITicketFormData;
  handleSelect: (name: string, value: any) => void;
  group: TicketGroup;
}

const Fields: React.FC<Props> = ({
  onClose,
  onOpen,
  form,
  handleSelect,
  group,
}) => {
  const ticketTypes = useSelector(selectTicketTypes);
  return (
    <>
      <TypeSelection
        type={form?.type}
        setValue={(val) => {
          handleSelect("type", val);
        }}
        ticketTypes={ticketTypes}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <SelectStatus
        status={form?.status}
        setValue={(val) => {
          handleSelect("status", val);
        }}
        defaultGroup={group}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <SelectAssignee
        assignedTo={form.assignedTo}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <PrioritySelection
        value={form.priority as string}
        setValue={(val) => {
          handleSelect("priority", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <TagSelection
        selectedTags={form?.tags}
        onTagsChange={(val) => {
          handleSelect("tags", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <DueDateSection
        dueDate={form?.dueDate}
        onDateChange={(val) => {
          handleSelect("dueDate", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
    </>
  );
};

export default Fields;
